import { Component, SimpleChanges, Input, ViewEncapsulation, forwardRef } from '@angular/core';
import { InputControlBase } from '../base/input-control-base/input-control.base';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-input-datetime-range-control',
  templateUrl: './input-datetime-range-control.component.html',
  styleUrls: ['./input-datetime-range-control.component.scss'],
  encapsulation: ViewEncapsulation.Native,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDatetimeRangeControlComponent),
      multi: true
    }
  ]
})
export class InputDatetimeRangeControlComponent extends InputControlBase<Date[]> {

  @Input('css')
  css: string = '';

  constructor(){
    super();
  }
  protected onInit(): void {
    this.initCss();
  }  
  protected onDestroy(): void {
  }
  protected onChanges(changes: SimpleChanges): void {
  }
  protected onDoCheck(): void {
  }
  protected onAfterContentInit(): void {
  }
  protected onAfterContentChecked(): void {
  }
  protected onAfterViewInit(): void {
  }
  protected onAfterViewChecked(): void {
  }

  private initCss() {
    this.defaultCss += ` ${this.css}`;
  }
}
